import React from "react";
// import React, { useCallback, useEffect, useState } from "react";
import Layout from "../shared/Layout";
import '../dashboard/dashboardcss/dashboard.css';
// import toast from "react-hot-toast";
// import { GetDashboardSummary, GetProductOrderDetailMonthly } from "../../_services";
// import BarChart from "../Reports/OrderReport/BarChart";
import { projectName } from "../../_config";

const Dashboard = () => {

    return (
        <Layout>
            <div className="px-4 my-3">
                <div className="dashboard_hedding">
                    <h3>Dashboard</h3>
                    <p>Welcome to {projectName}</p>
                </div>
                {/* <div className="mt-3 row">
                    <div className="col-lg-3">
                        <div className="shadow_box_draw">
                            <div className="total_sale_wepper">
                                <h5 className="business-analytics__subtitle">Total Sale</h5>
                                <img src="images/acquisition.png" alt=""></img>
                            </div>
                            <h2 className="business-analytics__title">{dashboardData?.totalOrder}</h2>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="shadow_box_draw">
                            <div className="total_sale_wepper">
                                <h5 className="business-analytics__subtitle">Total Products</h5>
                                <img src="images/box.png" alt=""></img>
                            </div>
                            <h2 className="business-analytics__title">{dashboardData?.totalProduct}</h2>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="shadow_box_draw">
                            <div className="total_sale_wepper">
                                <h5 className="business-analytics__subtitle">Total Customers</h5>
                                <img src="images/customer-service.png" alt=""></img>
                            </div>
                            <h2 className="business-analytics__title">{dashboardData?.totalCustomer}</h2>
                        </div>
                    </div>
                </div> */}

                {/* <div className="row my-4">
                        <div className="col-lg-3">
                            <div className="order-stats">
                                <div className="order-stats__content">
                                    <img width="20" src="images/pendding.png" alt="" />
                                    <h6 className="order-stats__subtitle mb-0">Total Order</h6>
                                </div>
                                <span className="order-stats__title">
                                    {dashboardData?.totalOrder}
                                </span>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="order-stats">
                                <div className="order-stats__content">
                                    <img width="20" src="images/circle-cheack.png" alt="" />
                                    <h6 className="order-stats__subtitle mb-0">Success Order</h6>
                                </div>
                                <span className="order-stats__title">
                                    {dashboardData?.totalSuccessOrderPayment}
                                </span>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="order-stats">
                                <div className="order-stats__content">
                                    <img width="20" src="images/package.png" alt="" />
                                    <h6 className="order-stats__subtitle mb-0">Pending Order</h6>
                                </div>
                                <span className="order-stats__title">
                                    {dashboardData?.totalPendingOrderPayment}
                                </span>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="order-stats">
                                <div className="order-stats__content">
                                    <img width="20" src="images/express-delivery-out.png" alt="" />
                                    <h6 className="order-stats__subtitle mb-0">Failed Order</h6>
                                </div>
                                <span className="order-stats__title">
                                    {dashboardData?.totalFailedOrderPayment}
                                </span>
                            </div>
                        </div>
                    </div> */}

                {/* <div className="row">
                    <div className="col-lg-3">
                        <div className="shadow_box_draw">
                            <div className="total_sale_wepper">
                                <h5 className="business-analytics__subtitle">Total Sale Amount</h5>
                                <img src="images/box.png" alt=""></img>
                            </div>
                            <h2 className="business-analytics__title">₹{dashboardData?.totalSale}</h2>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="shadow_box_draw">
                            <div className="total_sale_wepper">
                                <h5 className="business-analytics__subtitle">Total tax collected</h5>
                                <img src="images/box.png" alt=""></img>
                            </div>
                            <h2 className="business-analytics__title">₹{dashboardData?.totalTaxAmountPayment}</h2>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="shadow_box_draw">
                            <div className="total_sale_wepper">
                                <h5 className="business-analytics__subtitle">Delivery charge earned</h5>
                                <img src="images/box.png" alt=""></img>
                            </div>
                            <h2 className="business-analytics__title">₹{dashboardData?.totalDeliveryPayment}</h2>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="shadow_box_draw">
                            <div className="total_sale_wepper">
                                <h5 className="business-analytics__subtitle">Total Discount</h5>
                                <img src="images/box.png" alt=""></img>
                            </div>
                            <h2 className="business-analytics__title">₹{dashboardData?.totalDiscountPayment}</h2>
                        </div>
                    </div>
                </div> */}
                {/* <div className="datatable mt-4">
                    <BarChart
                        orderDataMonthly={orderDataMonthly}
                    />
                </div> */}
            </div>
        </Layout>
    )
}

export default Dashboard;